import styled from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const EcoConsumptionWrapper = styled.div`
    --or-list-border-color: ${theme.colors.platinumLight};
    --or-spacing-1: ${theme.space[1]}px;
    --or-spacing-2: ${theme.space[2]}px;
    --or-spacing-3: ${theme.space[3]}px;
    --or-color-grey-4: ${theme.colors.platinumLight};
    --or-list-highlighted-font-weight: 400;
    --or-eco-consumption-default-font-size: 1.4rem;
    --or-title-font-size: 1.6rem;
    --or-subtitle-font-size: 1.4rem;
    --title-base-font: ${theme.fonts.book};
    --or-list-hightlighted-font: ${theme.fonts.regular};
    --or-list-font-size: 1.4rem;
    --or-list-item-padding-x: 1.6rem;
    --list-gap: 0.8rem;

    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.platinumLight};

    .config-subitem {
        padding-inline: var(--list-item-padding-x, calc(var(--or-spacing-3) / 2));
    }
`;
